<template>
  <v-menu
    ref="timePickerMenu"
    v-model="timePicker"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        append-icon="access_time"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      format="24hr"
      v-model="time"
      no-title
      scrollable
      @input="$refs.timePickerMenu.save(time)"
    >
    </v-time-picker>
  </v-menu>
</template>
<script>
export default {
  props: ["label", "value"],
  data() {
    return {
      time: this.value,
      timePicker: false
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.time = newVal;
      },
      immediate: true
    },
    time(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
